import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { LuDownload } from "react-icons/lu";
import { FiEdit } from "react-icons/fi";


import "../css/WalkingCard.css";
import bottomImg from "../assets/cardoverbottom.png";
import topImg from "../assets/top-img.png";

const tagLabels = {
  popular: "Popular",
  great_deals: "Great Deals",
  steal_deals: "Steal Deals",
};

const badgeClassMap = {
  Popular: "walking-popular-badge",
  "Great Deals": "walking-greatDeals-badge",
  "Steal Deals": "walking-stealDeals-badge",
};

const WalkingCard = ({
  item,
  tag,
  isEditable = false,
  onClose,
  onSave,
  onAddService,
  onDelete,
}) => {
  const [editedTitle, setEditedTitle] = useState(item.title || "");
  const [editedDuration, setEditedDuration] = useState(item.duration || "");
  const [editedSubscribedPrice, setEditedSubscribedPrice] = useState(
    item.subscribedPrice || ""
  );
  const [editedUnsubscribedPrice, setEditedUnsubscribedPrice] = useState(
    item.unsubscribedPrice || ""
  );

  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [isEditingDuration, setIsEditingDuration] = useState(false);
  const [isEditingSubscribedPrice, setIsEditingSubscribedPrice] = useState(false);
  const [isEditingUnsubscribedPrice, setIsEditingUnsubscribedPrice] = useState(false);

  // Sync props with state if item changes
  useEffect(() => {
    setEditedTitle(item.title || "");
    setEditedDuration(item.duration || "");
    setEditedSubscribedPrice(item.subscribedPrice || "");
    setEditedUnsubscribedPrice(item.unsubscribedPrice || "");
  }, [item]);

  const renderBadge = () => {
    const label = tagLabels[tag] || tag;
    if (!label) return null;
    return <span className={badgeClassMap[label]}>{label}</span>;
  };

  const handleInputKeyDown = (e, field) => {
    if (e.key === "Enter") {
      if (field === "title") setIsEditingTitle(false);
      if (field === "duration") setIsEditingDuration(false);
      if (field === "subscribed") setIsEditingSubscribedPrice(false);
      if (field === "unsubscribed") setIsEditingUnsubscribedPrice(false);
    }
  };

  const handleSaveClick = () => {
    if (!editedTitle || !editedDuration || !editedSubscribedPrice || !editedUnsubscribedPrice) {
    
      return;
    }

    onSave({
      title: editedTitle,
      duration: editedDuration,
      subscribedPrice: editedSubscribedPrice,
      unsubscribedPrice: editedUnsubscribedPrice,
      tag,
    });


  };

  return (
    <motion.div
      className={`walking-package-card-wrapper ${isEditable ? "editable-modal" : ""}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.4 }}
    >
      {isEditable ? (
        <div className="walking-package-card walking-modal-card">
          <div className="walking-card-top-image">
            <img src={topImg} alt="top decoration" />
          </div>

          <div className="walking-package-card-body walking-edit-titles">
            {renderBadge()}

            {/* Title */}
            {isEditingTitle ? (
              <input
                className="walking-edit-input"
                value={editedTitle}
                onChange={(e) => setEditedTitle(e.target.value)}
                onBlur={() => setIsEditingTitle(false)}
                onKeyDown={(e) => handleInputKeyDown(e, "title")}
                autoFocus
              />
            ) : (
              <h3 className="walking-card-title" onClick={() => setIsEditingTitle(true)}>
                {editedTitle}
              </h3>
            )}

            {/* Duration */}
            {isEditingDuration ? (
              <input
                className="walking-edit-input"
                value={editedDuration}
                onChange={(e) => setEditedDuration(e.target.value)}
                onBlur={() => setIsEditingDuration(false)}
                onKeyDown={(e) => handleInputKeyDown(e, "duration")}
                autoFocus
              />
            ) : (
              <p className="walking-card-duration" onClick={() => setIsEditingDuration(true)}>
                {editedDuration}
              </p>
            )}

            {/* Pricing */}
            <div className="walking-card-pricing walking-edit-pricing">
              <p>
                Subscribed User Price: {" "}
                {isEditingSubscribedPrice ? (
                  <input
                    className="walking-edit-input small"
                    type="number"
                    value={editedSubscribedPrice}
                    onChange={(e) => setEditedSubscribedPrice(e.target.value)}
                    onBlur={() => setIsEditingSubscribedPrice(false)}
                    onKeyDown={(e) => handleInputKeyDown(e, "subscribed")}
                    autoFocus
                  />
                ) : (
                  <span onClick={() => setIsEditingSubscribedPrice(true)}>
                    ₹{editedSubscribedPrice}
                  </span>
                )}
              </p>
              <p>
                Unsubscribed User Price:{" "}
                {isEditingUnsubscribedPrice ? (
                  <input
                    className="walking-edit-input small"
                    type="number"
                    value={editedUnsubscribedPrice}
                    onChange={(e) => setEditedUnsubscribedPrice(e.target.value)}
                    onBlur={() => setIsEditingUnsubscribedPrice(false)}
                    onKeyDown={(e) => handleInputKeyDown(e, "unsubscribed")}
                    autoFocus
                  />
                ) : (
                  <span onClick={() => setIsEditingUnsubscribedPrice(true)}>
                    ₹{editedUnsubscribedPrice}
                  </span>
                )}
              </p>
            </div>

            {/* Save & Close Buttons */}
            <div className="walking-edit-btns">
              <button className="walking-save-btn" onClick={handleSaveClick}>
                <LuDownload /> Save
              </button>
              <span className="close-btn" onClick={onClose}>
                Close
              </span>
            </div>
          </div>

          <div className="walking-card-bottom-image">
            <img src={bottomImg} alt="bottom decoration" />
          </div>
        </div>
      ) : (
        <div className="walking-package-card">
          <div className="walking-card-top-image">
            <img src={topImg} alt="top decoration" />
          </div>

          <div className="walking-package-card-body">
            {renderBadge()}
            <h3 className="walking-card-title">{item.title}</h3>
            <p className="walking-card-duration">{item.duration}</p>

            <div className="walking-card-pricing">
              <p>
                Subscribed User Price: <span className="walking-price">₹{item.subscribedPrice}</span>
              </p>
              <p>
                Unsubscribed User Price: <span className="walking-price">₹{item.unsubscribedPrice}</span>
              </p>
            </div>

            <div className="walking-card-actions">
              <button className="Add-package-walking-edit-button" onClick={onAddService}>
                <FiEdit size={20} color="#000" /> Edit
              </button>
              <button className="Add-package-walking-delete-button" onClick={onDelete}>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24">
                  <path fill="#FF3D00" d="M9 17h2V8H9zm4 0h2V8h-2zm-8 4V6H4V4h5V3h6v1h5v2h-1v15z"/>
                </svg>
              </button>
            </div>
          </div>

          <div className="walking-card-bottom-image">
            <img src={bottomImg} alt="bottom decoration" />
          </div>
          
        </div>
        
      )}
    </motion.div>
  );
};

export default WalkingCard;
